var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"data-app":"","wrap":"","row":""}},[_c('v-flex',{staticClass:"align-self-center",attrs:{"xs12":""}},[_c('h1',[_vm._v("Reports TEST = "+_vm._s(this.testId))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }